export var hitEvent = function hitEvent(src) {
  var useBeacon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (typeof window !== 'undefined' && 'navigator' in window && useBeacon) {// идеальный мир, где статистику отправляем через sendBeacon,
    // но мы не можем отправить POST запрос, не знаем как поведут себя системы
    // window.navigator.sendBeacon(src);
  } else {
    new Image().src = src;
  }
};